import tagHttpService from '../_services/tagHttpService'
import { GET_ALL_TAGS, GET_SPECIFIC_TAG, GET_TAG_USE } from './mutation-types'

export default {
  listarTags: async ({ commit }) => {
    try {
      const response = await tagHttpService.getTags()
      commit(GET_ALL_TAGS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTagEspecifica: async ({ commit }, id) => {
    try {
      const response = await tagHttpService.getSpecificTag(id)
      commit(GET_SPECIFIC_TAG, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTagUse: async ({ commit },id) => {
    try {
      const response = await tagHttpService.getTagUse(id)
      commit(GET_TAG_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
